import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Col, Row, VertButton, VertTypography } from '@vertem-core/vertice-ds';
import { balanceUser } from '../BalanceUser';

import { pointsMask } from 'Utils/commons/points';
import DollarSvg from 'components/Icon/DollarSvg';
import { BALANCE_SHOW_HIDE } from 'redux/Reducers/Balance/BalanceReducer';
import { LuEye, LuEyeOff } from 'react-icons/lu';

const handleBalance = ({ value, label, hideCurrency, isHiden }) => {
  if(isHiden) return `***** ${label}`

  return `${value}${hideCurrency ? '' : ` ${label}`}`;
};

const HeaderPoints = ({ isProfile = true }) => {
  const Balance = useSelector(({ Balance: data }) => data);
  const Catalog = useSelector(({ Catalog: data }) => data);

  const dispatch = useDispatch();

  const strToLowercase = (str) => str.toLowerCase();
  const colorIconResponsive = getComputedStyle(
    document.documentElement
  ).getPropertyValue('--header-color-icon-dollar-responsive');

  const { pointsValue,hidePoints } = Balance;
  const {
    currencyConfiguration: { decimalPlaces, pointsName },
  } = Catalog;
  const balanceValue = handleBalance({
    ...pointsMask(pointsValue, decimalPlaces, pointsName),
    hideCurrency: true,
  });
  const balanceLabel = handleBalance({
    ...pointsMask(pointsValue, decimalPlaces, pointsName),
    hideCurrency: false,
    isHiden: hidePoints
  });

  const classNameWrapper = isProfile
    ? 'header-profile-points'
    : 'header-points-content';

  return (
    <div
      className={classNameWrapper}
      aria-label={`Saldo: ${balanceUser(balanceLabel, true)}`}
    >
      {isProfile ? (
        <>
          Saldo:
          <VertTypography.Paragraph aria-hidden="true">
            {balanceUser(balanceLabel, true)}
          </VertTypography.Paragraph>
          <VertButton
              className='vert-button'
              type="link"
              shape={'default'}
              size={'small'}
              onClick={() => {
                dispatch({type: BALANCE_SHOW_HIDE, payload: {hidePoints: !hidePoints}})
              }}
              icon={!hidePoints ? <LuEye className='icon-lueye' size={18} display={'block'}/> : <LuEyeOff className="icon-lueye" size={18}  display={'block'}/>}
            />       
        </>
      ) : (
        <div
          className="header-points-icon"
          aria-label={`Saldo: ${balanceUser(balanceLabel, true)}`}
        >
          <Row gutter={0} align='middle'>
            <Col className="col-auto">
              <DollarSvg
                color={colorIconResponsive}
                size={24}
                className="lucide color-highlight txt-balance-icon"
                aria-hidden="true"
              />
            </Col>
            <Col className="col-auto">
              <VertTypography.Paragraph
                className="txt-balance-label"
                aria-hidden="true"
              >
                Saldo:
              </VertTypography.Paragraph>
            </Col>
            <Col className="col-auto">
              <VertTypography.Paragraph
                className="txt-balance-value"
                aria-hidden="true"
              >
                {hidePoints ? "*****" : balanceUser(balanceValue, true)} {strToLowercase(pointsName)}
              </VertTypography.Paragraph>
            </Col>
            <VertButton
              type="link"
              shape={'default'}
              size={'small'}
              onClick={() => {
                dispatch({type: BALANCE_SHOW_HIDE, payload: {hidePoints: !hidePoints}})
              }}
              icon={!hidePoints ? <LuEye size={18} className='icon-lueye' display={'block'}/> : <LuEyeOff size={18} className='icon-lueye' display={'block'}/>}
            />
          </Row>
        </div>
      )}
    </div>
  );
};

export default HeaderPoints;
